import _classCallCheck from "/apps/packages/ui/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/apps/packages/ui/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
var SIGNATURE = 'alibi-tech-message';
var DEBUG = false;
export var WidgetLib = /*#__PURE__*/function () {
  function WidgetLib() {
    _classCallCheck(this, WidgetLib);
  }

  _createClass(WidgetLib, null, [{
    key: "sendParent",
    value: function sendParent(payload) {
      if (window.parent) {
        DEBUG && console.log("WidgetLib.sendParent", payload);
        window.parent.postMessage(payload, '*');
      } else {
        DEBUG && console.log("WidgetLib.sendParent skipped - no parent", payload);
      }
    }
  }, {
    key: "setSize",
    value: function setSize(size) {
      WidgetLib.sendParent({
        SIGNATURE: SIGNATURE,
        messageType: 'resize',
        newSize: size
      });
    }
  }, {
    key: "widgetMessage",
    value: function widgetMessage(origin, event) {
      DEBUG && console.log("WidgetLib.isWidgetMessage ", {
        origin: origin,
        event: event,
        s: event.data['SIGNATURE'],
        SIGNATURE: SIGNATURE
      });
      return event.origin === origin && event.data['SIGNATURE'] === SIGNATURE ? event.data : undefined;
    }
  }]);

  return WidgetLib;
}();